import { useI18n } from "@/contexts/i18nContext";
import { cx, round } from "@/utils";

import { widgetTitle } from "../helpers";

import styles from "./CountText.module.css";

const CountText = (props) => {
  const {
    className,
    size,
    count,
    testId,
    isCompact,
    extraHeader,
    isCurrency = false,
    noTitle,
  } = props;

  const { abbreviateCurrency, abbreviateNumber } = useI18n();

  const countText = isCurrency
    ? abbreviateCurrency(round(count))
    : abbreviateNumber(round(parseInt(count)));

  return (
    <div
      className={cx(
        styles.root,
        {
          [styles.compact]: isCompact,
          [styles.size3]: size === 3,
          [styles.size4]: size === 4,
          [styles.size6]: size === 6,
          [styles.size12]: size === 12,
        },
        className
      )}
    >
      <div className={styles.count} data-testid={testId || null}>
        {countText}
      </div>

      <div className={styles.container}>
        <h5>
          {noTitle ? null : isCompact && widgetTitle(props)}
          {isCompact && extraHeader}
        </h5>
      </div>
    </div>
  );
};

export { CountText };
